// Angular
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
// RxJS
import { map, tap } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// Auth reducers and selectors
import { AppState} from '../state/root/';
import { selectLoggedInUser } from '../state/user/user.selectors';


export const adminGuard: CanActivateFn =
(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const store: Store<AppState> = inject(Store<AppState>);
    return store.pipe(
        select(selectLoggedInUser),
        map(e => {
            return e.isAdmin
        })
    )
};